import { FieldState } from './typings'
import { GridColDef, GridColumnVisibilityModel } from '@mui/x-data-grid-pro'
import { CustomField } from '@sales-center/common'
import { createCustomFieldColumns } from './createCustomFieldColumns'

export function arrangeColumns(
  fieldStates: FieldState[],
  allColumns: GridColDef[],
  lockedFields: string[],
  customFields: CustomField[] = [],
  hasSSOErrors?: boolean,
): [GridColDef[], GridColumnVisibilityModel] {
  const [customColumns, customVisibility] =
    createCustomFieldColumns(customFields)

  const columns = [...allColumns, ...customColumns]
  const visibility: GridColumnVisibilityModel = { ...customVisibility }

  if (fieldStates.length === 0) {
    columns.map(({ field }) => void (visibility[field] = true))
    return [columns, visibility]
  }

  const orderedColumns = fieldStates.reduce<GridColDef[]>(
    (prev, { field, hide, width }) => {
      const index = columns.findIndex((c) => c.field === field)
      if (index !== -1) {
        const column = columns.splice(index, 1).pop()!
        visibility[field] = !hide
        if (column.field === 'errors') visibility[field] = !!hasSSOErrors
        else visibility[field] = !hide
        if (width) {
          column.width = parseInt(width)
        }
        return [...prev, column]
      }
      return prev
    },
    [],
  )

  // keep bulk action error column in front
  const index = columns.findIndex((c) => c.field === '__bulkErrors__')
  if (index !== -1) {
    const col = columns.splice(index, 1).pop()!
    orderedColumns.unshift(col)
  }

  // keep locked columns visibile
  lockedFields.map((l) => (visibility[l] = true))

  let finalColumns = [...orderedColumns, ...columns]
  if (!visibility['errors'] && hasSSOErrors !== undefined) {
    visibility['errors'] = hasSSOErrors
  }

  if (!hasSSOErrors)
    finalColumns = finalColumns.filter((col) => col.field !== 'errors')
  return [finalColumns, visibility]
}
